/** settlement group: ledger, write-offs, cash, rails (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const settlementPermissions = [
  'settlement:read',
  'writeoff:post',
  'cash:record',
  'payment:log',
  'payment:confirm',
  'rail:manage',
] as const;

export type SettlementPermission = (typeof settlementPermissions)[number];
